module.exports = "<p>and get unlimited entry to <em>Pipilotti Rist: Sip my Ocean</em></p> <font color=white>-</font> <p><em>Pipilotti Rist: Sip my Ocean</em> is set to dazzle audiences. Join as an MCA Member and see the exhibition as many times as you want for free, because one visit won’t be enough to take in the work of the renowned Swiss artist.</p> <p>Members join an art-loving community and gain an inside view of life at the MCA. Membership gives you access to exclusive events and pre-sales for workshops, artist talks and special events.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/markdown/pages/tickets_4.md
// module id = 223
// module chunks = 0